import { ContactGroupType } from 'contacts/enums';
import { contactGroupService, vendorService } from 'contacts/services';
import { IContactGroupAddress, IVendor, IVendorSearchRequestPayload } from 'contacts/types';
import { NON_EMPTY } from 'core/constants';
import { useInfiniteQuery } from 'core/hooks';
import { IInfiniteQueryOptions } from 'core/types';

export const useGetVendorsSearch = (
  requestPayload: IVendorSearchRequestPayload,
  options: IInfiniteQueryOptions<IContactGroupAddress> = {}
) =>
  useInfiniteQuery<IContactGroupAddress>(
    contactGroupService.getContactGroupAddresses,
    'vendorsSearch',
    {
      ...requestPayload,
      filters: {
        ...(requestPayload?.filters ?? {}),
        contactGroupType: ContactGroupType.VENDOR,
        accountsPayableId: NON_EMPTY,
      },
    },
    options
  );

export const useGetLegacyVendorsSearch = (
  requestPayload: IVendorSearchRequestPayload,
  options: IInfiniteQueryOptions<IVendor> = {}
) => {
  const { filters, ...requestPayloadWithoutFilters } = requestPayload ?? {};
  const { query } = filters ?? {};

  return useInfiniteQuery<IVendor>(
    vendorService.getManyAutocomplete,
    'legacyVendorsSearch',
    {
      ...requestPayloadWithoutFilters,
      q: query,
      viewBy: { alternateVersionEnabled: 0 },
    },
    options
  );
};
